import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img01.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#1d8633" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Leveraging Mobile Apps for Massive Business Growth in Los Angeles
            </h2>
            <p>
              Mobile apps have become essential tools for enhancing customer
              engagement, streamlining operations, and expanding brand reach.
              Our mobile app development expertise empowers Los Angeles
              businesses to harness this digital revolution effectively. Through
              custom-tailored solutions, we help you tap into a dynamic market,
              connecting with your audience on their smartphones and
              tablets.With a mobile app designed to suit your unique needs, you
              can enhance customer experiences, improve operational efficiency,
              and ultimately boost revenue.
            </p>
            <p>
              Los Angeles is a city of innovation, and our team of experts is
              here to ensure that your business thrives within this vibrant
              ecosystem.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#1d8633",
                border: "1px solid #1d8633",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
